var _rect, _path, _g, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRomanticPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 122,
    viewBox: "0 0 80 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 54,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4993 76.4297C24.9603 76.4297 23.179 78.1328 23.179 80.4375V80.4531C23.179 82.5859 24.6556 84.1484 26.8509 84.1484C28.4134 84.1484 29.3509 83.3672 29.7572 82.5H29.9134C29.9134 82.5859 29.9134 82.6719 29.9134 82.75C29.8275 84.8047 29.1087 86.4062 27.4759 86.4062C26.5697 86.4062 25.929 85.9297 25.6556 85.2266L25.6322 85.1562H23.3197L23.3353 85.2266C23.6868 86.9922 25.304 88.2812 27.4837 88.2812C30.3743 88.2812 32.1556 86.0391 32.1556 82.2656V82.25C32.1556 78.2891 30.1087 76.4297 27.4993 76.4297ZM27.4993 82.4062C26.3197 82.4062 25.4603 81.5547 25.4603 80.3672V80.3516C25.4603 79.2031 26.3743 78.3047 27.515 78.3047C28.6634 78.3047 29.5618 79.2188 29.5618 80.3984V80.4141C29.5618 81.5781 28.6634 82.4062 27.4993 82.4062ZM36.9844 88H39.3438V76.7266H36.9922L34.0781 78.75V80.875L36.8438 78.9531H36.9844V88ZM44.8991 82.9062C46.5554 82.9062 47.5632 81.6875 47.5632 79.7344V79.7266C47.5632 77.7734 46.5554 76.5625 44.8991 76.5625C43.2507 76.5625 42.235 77.7734 42.235 79.7266V79.7344C42.235 81.6875 43.2507 82.9062 44.8991 82.9062ZM46.6179 88L54.2194 76.7266H52.4304L44.8288 88H46.6179ZM44.8991 81.6562C44.2194 81.6562 43.8366 80.9609 43.8366 79.7344V79.7266C43.8366 78.4922 44.2194 77.8125 44.8991 77.8125C45.5866 77.8125 45.9694 78.4922 45.9694 79.7266V79.7344C45.9694 80.9609 45.5866 81.6562 44.8991 81.6562ZM54.1413 88.1641C55.7975 88.1641 56.8054 86.9453 56.8054 84.9922V84.9844C56.8054 83.0312 55.7975 81.8203 54.1413 81.8203C52.4929 81.8203 51.4772 83.0312 51.4772 84.9844V84.9922C51.4772 86.9453 52.4929 88.1641 54.1413 88.1641ZM54.1413 86.9141C53.4616 86.9141 53.0788 86.2188 53.0788 84.9922V84.9844C53.0788 83.75 53.4616 83.0703 54.1413 83.0703C54.8288 83.0703 55.2116 83.75 55.2116 84.9844V84.9922C55.2116 86.2188 54.8288 86.9141 54.1413 86.9141Z",
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 54C46.7426 54 53.2587 56.433 58.3512 60.8521C63.4437 65.2712 66.7706 71.3795 67.7207 78.0548C68.6707 84.7301 67.1801 91.524 63.5226 97.1884C59.8652 102.853 54.2866 107.007 47.8117 108.888C41.3369 110.769 34.4007 110.251 28.2775 107.428C22.1543 104.605 17.2554 99.6676 14.4807 93.5224C11.706 87.3772 11.2421 80.4372 13.174 73.9773C15.1059 67.5174 19.3039 61.9717 24.9969 58.3588",
    stroke: "#FF0000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30.4614C36.5228 30.4614 41 25.7096 41 19.8479C41 13.9862 36.5228 9.23444 31 9.23444C25.4772 9.23444 21 13.9862 21 19.8479C21 25.7096 25.4772 30.4614 31 30.4614Z",
    fill: "#FFEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3511 25.5709C11.8713 20.4191 20.3943 5.13637 26.8891 11.9806C29.2613 2.6372 43.9077 11.3896 30.3511 25.5709Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1904 42.8058C50.7715 42.8058 47.9999 39.8642 47.9999 36.2355C47.9999 32.6069 50.7715 29.6653 54.1904 29.6653C57.6093 29.6653 60.3809 32.6069 60.3809 36.2355C60.3809 39.8642 57.6093 42.8058 54.1904 42.8058Z",
    fill: "#FFEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5924 39.7782C66.0323 36.589 60.7561 27.1283 56.7355 31.3651C55.267 25.5812 46.2002 30.9993 54.5924 39.7782Z",
    fill: "#FF0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_4",
    x: 0,
    y: 42,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_4",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomanticPercent);
export default __webpack_public_path__ + "static/media/romantic-percent.250e91294e96b80556b9032b97dcf207.svg";
export { ForwardRef as ReactComponent };